import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { DonhangsanphamAction } from 'src/actions/donhangsanpham.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getDonhangsanphamStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Select as Select1,
  MenuItem,
  Button,
} from '@material-ui/core';

import { Helmet } from "react-helmet";

import { Dialog, DialogTitle, DialogContent, Button as Button1 } from "@mui/material";

import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

const DonhangsanphamLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedDonhangsanphamIds, setSelectedDonhangsanphamIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.donhangsanpham);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  const [openModalLichSuTrangThai, setOpenModalLichSuTrangThai] = useState(false);
  const [contentModalLichSuTrangThai, setContentModalLichSuTrangThai] = useState("");

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(DonhangsanphamAction.updateFilter(payload));
    dispatch(DonhangsanphamAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedDonhangsanphamIds;

    if (event.target.checked) {
      newSelectedDonhangsanphamIds = items.map((donhangsanpham) => donhangsanpham.id);
    } else {
      newSelectedDonhangsanphamIds = [];
    }

    setSelectedDonhangsanphamIds(newSelectedDonhangsanphamIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedDonhangsanphamIds.indexOf(id);
    let newSelectedDonhangsanphamIds = [];

    if (selectedIndex === -1) {
      newSelectedDonhangsanphamIds = newSelectedDonhangsanphamIds.concat(selectedDonhangsanphamIds, id);
    } else if (selectedIndex === 0) {
      newSelectedDonhangsanphamIds = newSelectedDonhangsanphamIds.concat(selectedDonhangsanphamIds.slice(1));
    } else if (selectedIndex === selectedDonhangsanphamIds.length - 1) {
      newSelectedDonhangsanphamIds = newSelectedDonhangsanphamIds.concat(selectedDonhangsanphamIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedDonhangsanphamIds = newSelectedDonhangsanphamIds.concat(
        selectedDonhangsanphamIds.slice(0, selectedIndex),
        selectedDonhangsanphamIds.slice(selectedIndex + 1)
      );
    }

    setSelectedDonhangsanphamIds(newSelectedDonhangsanphamIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, donhangsanpham) => {
    setSelected(donhangsanpham);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(DonhangsanphamAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(DonhangsanphamAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'da_thanh_toan') return 'green';
    else if (value == 'chua_thanh_toan') return 'red';
    else if (value == 'chua_giao') return 'red';
    else if (value == 'dang_van_chuyen') return 'orange';
    else if (value == 'giao_thanh_cong') return 'green';
    else if (value == 'don_hang_that_lac') return 'red';
    else if (value == 'xu_ly_thanh_cong') return 'green';
    else if (value == 'online') return 'green';
    else if (value == 'cod') return 'blue';
    else if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  const setTrangThaiThuTien = async (id, value) => {
    dispatch(DonhangsanphamAction.update(id, { 
      trang_thai: value,
    }))
  }

  return (<>
    <Helmet>
      <style>{`
          
      `}</style>
    </Helmet>

    <Dialog className='lich_su_trang_thai_modal' open={openModalLichSuTrangThai} onClose={() => setOpenModalLichSuTrangThai(false)}>
      <DialogTitle></DialogTitle>
      <DialogContent>
        {contentModalLichSuTrangThai && <div>
          {contentModalLichSuTrangThai.split('\n').map((line, index) => (<>
            {line && line != "" && <>
              <p key={index}>- <span dangerouslySetInnerHTML={{ __html: line }} ></span></p>
              <br></br>
            </>}
          </>))}
        </div>}
      </DialogContent>
      <Button onClick={() => setOpenModalLichSuTrangThai(false)}>Đóng</Button>
    </Dialog>

    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: '500px', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Loại sản phẩm
                </TableCell>
                <TableCell>
                  Tên KH
                </TableCell>
                <TableCell>
                  SĐT đặt hàng
                </TableCell>
                <TableCell>
                  Địa chỉ chi tiết
                </TableCell>
                <TableCell>
                  Phường/xã
                </TableCell>
                <TableCell>
                  Quận/huyện
                </TableCell>
                <TableCell>
                  Tỉnh/thành
                </TableCell>
                <TableCell>
                  ID đơn hàng
                </TableCell>
                <TableCell>
                  Tên SP
                </TableCell>
                <TableCell>
                  Giá
                </TableCell>
                <TableCell>
                  Hình thức thanh toán
                </TableCell>
                <TableCell>
                  Phí
                </TableCell>
                <TableCell>
                  Thực thu
                </TableCell>
                <TableCell>
                  Trạng thái
                </TableCell>
                <TableCell>
                  Ghi chú
                </TableCell>
                <TableCell>
                  Thời điểm tạo đơn
                </TableCell>
                <TableCell>
                  Chức năng
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((donhangsanpham, index) => (
                donhangsanpham ? <TableRow
                  hover
                  key={donhangsanpham.id}
                  selected={selectedDonhangsanphamIds.indexOf(donhangsanpham.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>
                    {donhangsanpham.donhangsanpham_product_type == "xe_may_dien" && <span style={{ }}>Xe máy điện</span>}
                    {donhangsanpham.donhangsanpham_product_type == "xe_dap_dien" && <span style={{ }}>Xe đạp điện</span>}
                    {donhangsanpham.donhangsanpham_product_type == "ac_quy" && <span style={{ }}>Ắc quy</span>}
                    {donhangsanpham.donhangsanpham_product_type == "pin" && <span style={{ }}>Pin</span>}
                    {donhangsanpham.donhangsanpham_product_type == "phu_tung" && <span style={{ }}>Phụ tùng</span>}
                    {donhangsanpham.donhangsanpham_product_type == "khac" && <span style={{ }}>Khác</span>}
                  </TableCell>
                  <TableCell>
                    {donhangsanpham.name}
                    {donhangsanpham.note && donhangsanpham.note != "" && <>
                      <br></br>
                      <br></br>
                      <span style={{color: 'red'}}>* {donhangsanpham.note}</span>
                    </>}
                  </TableCell>
                  <TableCell>
                    <span style={{color: 'blue', fontWeight: 'bold'}}>{donhangsanpham.phone}</span>
                  </TableCell>
                  <TableCell>
                    {donhangsanpham.address ? donhangsanpham.address : '-'}
                  </TableCell>
                  <TableCell>
                    {donhangsanpham.ward_name ? donhangsanpham.ward_name : '-'}
                  </TableCell>
                  <TableCell>
                    {donhangsanpham.district_name ? donhangsanpham.district_name : '-'}
                  </TableCell>
                  <TableCell>
                    {donhangsanpham.province_name ? donhangsanpham.province_name : '-'}
                  </TableCell>
                  <TableCell>
                    <span style={{color: 'purple', fontWeight: 'bold'}}>{donhangsanpham.id}</span>
                  </TableCell>
                  <TableCell>
                      <span style={{color: 'teal', fontWeight: 'bold'}}>{donhangsanpham.donhangsanpham_name}</span>
                      <br></br>
                      <br></br>
                      {donhangsanpham.priceName && <>
                        (<span style={{color: 'blue', fontWeight: 'bold'}}>{donhangsanpham.priceName}</span>)
                        <br></br>
                        <br></br>
                      </>}
                      (SL: <span style={{color: 'red', fontWeight: 'bold'}}>{numeral(donhangsanpham.quantity).format('0,0')}</span>)
                  </TableCell>
                  <TableCell>
                    <span style={{color: 'red', fontWeight: 'bold'}}>{numeral(Number(donhangsanpham.donhangsanpham_price_new) > 0 && Number(donhangsanpham.donhangsanpham_price_new) < Number(donhangsanpham.donhangsanpham_price) ? donhangsanpham.donhangsanpham_price_new : donhangsanpham.donhangsanpham_price).format('0,0')}₫</span>
                  </TableCell>
                  <TableCell>
                    <span style={{color: setColor(donhangsanpham.payment_method)}}>{donhangsanpham.payment_method == 'online' ? 'Chuyển khoản' : 'COD'}</span>
                  </TableCell>
                  <TableCell>
                    {numeral(Number(donhangsanpham.phi)).format('0,0')}
                  </TableCell>
                  <TableCell>
                    {numeral(Number(donhangsanpham.thuc_thu)).format('0,0')}
                  </TableCell>
                  <TableCell>
                    <Select1 
                      style={{
                          fontSize: '14px',
                          width: '120px',
                          marginBottom: '15px',
                          color: setColor(donhangsanpham.trang_thai)
                        }}
                        variant="outlined"
                        value={donhangsanpham.trang_thai}
                        onChange={(e) =>
                          setTrangThaiThuTien(donhangsanpham.id, e.target.value)
                        }
                      >
                      <MenuItem
                        style={{ color: setColor('chua_giao') }}
                        value="chua_giao"
                      >
                        Chưa giao
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('dang_van_chuyen') }}
                        value="dang_van_chuyen"
                      >
                        Đang vận chuyển
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('giao_thanh_cong') }}
                        value="giao_thanh_cong"
                      >
                        Giao thành công
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('don_hang_that_lac') }}
                        value="don_hang_that_lac"
                      >
                        Đơn hàng thất lạc
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('xu_ly_thanh_cong') }}
                        value="xu_ly_thanh_cong"
                      >
                        Xử lý thành công
                      </MenuItem>
                    </Select1>
                    {donhangsanpham.lich_su_trang_thai && <Button
                      color="primary"
                      variant="contained"
                      onClick={(e) => { setContentModalLichSuTrangThai(donhangsanpham.lich_su_trang_thai ? donhangsanpham.lich_su_trang_thai : ''); setOpenModalLichSuTrangThai(true); }}
                      style={{ height: '20px', padding: 0, marginTop: 0, width: '80px', minWidth: '20px', marginLeft: '5px', color: 'purple', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: 16, bdonhangsanpham: '1px solid transparent' }}
                      >
                      Xem lịch sử
                    </Button>}
                  </TableCell>
                  <TableCell>
                    {donhangsanpham.ghi_chu_don_hang ? donhangsanpham.ghi_chu_don_hang : '-'}
                  </TableCell>
                  <TableCell>
                    {moment(donhangsanpham.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(donhangsanpham.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    {(role.priority < 3) && <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, donhangsanpham)}>
                      <Trash2Icon color='red' />
                    </IconButton>}
                  </TableCell>
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  </>);
};

export default DonhangsanphamLookupDetail;
